import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import AdminSidebar from '../../components/AdminSidebar';
import AdminTopBar from '../../components/AdminTopBar';
import { API_BASE_URL } from '../../config';

const API = API_BASE_URL;

export default function AdminNewUserSurvey() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [key, setKey] = useState('new-user');
  const [questions, setQuestions] = useState([]);
  const dragState = useRef({ src: -1, over: -1 });
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const [qType, setQType] = useState('checkbox');
  const [qLabel, setQLabel] = useState('');
  const [qOptions, setQOptions] = useState('');
  const [qSaveToProfile, setQSaveToProfile] = useState(false);
  const [qProfileKey, setQProfileKey] = useState('');
  const [publishAt, setPublishAt] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [targetType, setTargetType] = useState('all');
  const [targetIds, setTargetIds] = useState('');

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => { fetchTemplates(); const id = searchParams.get('id'); if (id) loadTemplate(Number(id)); }, []);

  async function fetchTemplates() {
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/surveys/templates`, { credentials: 'include' });
      const j = await r.json();
      setTemplates(j.templates || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  }

  async function loadTemplate(id) {
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/surveys/templates`, { credentials: 'include' });
      const j = await r.json();
      const t = (j.templates || []).find(x => x.id === id);
      if (t) {
        setEditingId(t.id);
        setTitle(t.title || '');
        setKey(t.key || '');
        setQuestions(t.questions || []);
        setPublishAt(t.publishAt ? new Date(t.publishAt).toISOString().slice(0,16) : '');
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  }

  function onDragStart(e, idx) {
    dragState.current.src = idx;
    try { e.dataTransfer.setData('text/plain', String(idx)); } catch (err) {}
    e.dataTransfer.effectAllowed = 'move';
  }

  function onDragOver(e, idx) {
    e.preventDefault();
    dragState.current.over = idx;
  }

  function onDrop(e, idx) {
    e.preventDefault();
    const src = dragState.current.src;
    const dest = idx;
    if (src === -1 || dest === -1 || src === dest) return;
    setQuestions(prev => {
      const arr = [...prev];
      const [item] = arr.splice(src, 1);
      arr.splice(dest, 0, item);
      return arr;
    });
    dragState.current.src = -1;
    dragState.current.over = -1;
  }

  function onDragEnd() {
    dragState.current.src = -1;
    dragState.current.over = -1;
  }

  function addQuestion() {
    const opts = (qOptions || '').split(',').map(s => s.trim()).filter(Boolean);
    setQuestions(prev => [...prev, { id: `q${prev.length+1}`, type: qType, label: qLabel, options: opts, saveToProfile: !!qSaveToProfile, profileKey: qProfileKey || undefined }]);
    setQLabel(''); setQOptions(''); setQSaveToProfile(false); setQProfileKey('');
  }

  function suggestProfileKeyFromLabel(label) {
    if (!label) return '';
    const s = label.toLowerCase();
    if (s.includes('serv') || s.includes('porsiyon')) return 'servingSize';
    if (s.includes('iş') || s.includes('meslek') || s.includes('job') || s.includes('title')) return 'jobTitle';
    if (s.includes('telefon') || s.includes('tel') || s.includes('phone')) return 'phone';
    if (s.includes('avatar') || s.includes('foto') || s.includes('resim')) return 'avatar';
    if (s.includes('dil') || s.includes('locale') || s.includes('lang')) return 'locale';
    if (s.includes('ad') || s.includes('isim') || s.includes('name')) return 'name';
    if (s.includes('sıklık') || s.includes('frequency')) return 'frequency';
    if (s.includes('tercih') || s.includes('preference')) return 'preferences';
    if (s.includes('diyet')) return 'diet';
    if ((s.includes('gün') && s.includes('yemek')) || s.includes('cooking') || s.includes('cookingday')) return 'cookingDays';
    return label.replace(/[^a-zA-Z0-9_]/g, '_').replace(/__+/g, '_').toLowerCase();
  }

  async function saveTemplate() {
    if (!title || !questions.length) return alert('Başlık ve en az 1 soru gerekli');
    try {
      const body = { key, title, questions, audience: 'all', activeForNewUsers: true, publishAt: publishAt ? new Date(publishAt).toISOString() : null };
      let r, j;
      if (editingId) {
        r = await fetch(`${API}/api/surveys/templates/${editingId}`, { method: 'PATCH', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        j = await r.json();
      } else {
        r = await fetch(`${API}/api/surveys/templates`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        j = await r.json();
      }
      if (!j.ok) return alert('Kaydetme hatası: ' + (j.error || ''));
      alert('Kaydedildi');
      fetchTemplates();
    } catch (e) { console.error(e); alert('hata'); }
  }

  async function assignNow(templateId) {
    try {
      const t = { type: targetType };
      if (targetType === 'list') t.ids = (targetIds || '').split(',').map(s => Number(s.trim())).filter(Boolean);
      const r = await fetch(`${API}/api/surveys/assign`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ templateId, target: t }) });
      const j = await r.json();
      if (!j.ok) return alert('Atama hatası: ' + (j.error || ''));
      alert(`Atandı: ${j.assigned}`);
    } catch (e) { console.error(e); alert('hata'); }
  }

  return (
    <div className="flex h-screen w-full">
      <AdminSidebar mobileOpen={mobileSidebarOpen} onCloseMobile={() => setMobileSidebarOpen(false)} />
      <main className="flex-1 flex flex-col h-full overflow-hidden bg-background-light relative md:ml-[var(--admin-sidebar-width,18rem)] transition-[margin] duration-300">
        <AdminTopBar onToggleMobile={() => setMobileSidebarOpen(open => !open)} />

        <div className="flex-1 overflow-y-auto p-6 lg:p-10">
          <div className="bg-white p-4 rounded shadow max-w-3xl">
            <h2 className="text-xl font-bold mb-4">Yeni Kullanıcı Anketi — Oluştur / Yönet</h2>

            <label className="block text-sm">Başlık</label>
            <input className="w-full mb-2" value={title} onChange={e=>setTitle(e.target.value)} />
            <label className="block text-sm">Key</label>
            <input className="w-full mb-2" value={key} onChange={e=>setKey(e.target.value)} />

            <label className="block text-sm">Yayın Tarihi (isteğe bağlı)</label>
            <input type="datetime-local" className="w-full mb-3" value={publishAt} onChange={e=>setPublishAt(e.target.value)} />

            <div className="border p-2 rounded mb-2">
              <div className="flex gap-2 items-center mb-2">
                <select value={qType} onChange={e=>setQType(e.target.value)} className="p-1">
                  <option value="checkbox">Checkbox</option>
                  <option value="dropdown">Dropdown</option>
                </select>
                <input placeholder="Soru metni" value={qLabel} onChange={e=>setQLabel(e.target.value)} className="flex-1 p-1" />
              </div>
              <div className="mb-2">
                <label className="text-xs">Seçenekler (virgülle ayır)</label>
                <input value={qOptions} onChange={e=>setQOptions(e.target.value)} className="w-full p-1" />
              </div>
              <div className="flex items-center gap-3 mb-2">
                <label className="inline-flex items-center gap-2">
                  <input type="checkbox" checked={qSaveToProfile} onChange={e=>setQSaveToProfile(e.target.checked)} className="h-4 w-4" />
                  <span className="text-sm">Kullanıcı profiline yaz</span>
                </label>
                <select value={qProfileKey || 'none'} onChange={e=>setQProfileKey(e.target.value === 'custom' ? '' : (e.target.value === 'none' ? '' : e.target.value))} className="p-1 border rounded">
                  <option value="none">-- Profil anahtarı seç (opsiyonel) --</option>
                  <option value="servingSize">servingSize</option>
                  <option value="jobTitle">jobTitle</option>
                  <option value="phone">phone</option>
                  <option value="avatar">avatar</option>
                  <option value="locale">locale</option>
                  <option value="name">name</option>
                  <option value="frequency">frequency</option>
                  <option value="preferences">preferences</option>
                  <option value="diet">diet</option>
                  <option value="cookingDays">cookingDays</option>
                  <option value="custom">Özel...</option>
                </select>
                <button type="button" onClick={() => setQProfileKey(suggestProfileKeyFromLabel(qLabel || ''))} className="ml-2 px-2 py-1 border rounded text-sm">Öner</button>
                {qProfileKey === '' && (
                  <input placeholder="Özel anahtar girin" value={qProfileKey} onChange={e=>setQProfileKey(e.target.value)} className="p-1 border rounded flex-1" />
                )}
              </div>
              <button onClick={addQuestion} className="px-3 py-1 bg-primary text-white rounded">Soru Ekle</button>
            </div>

            <div className="mb-2">
              <h4 className="text-sm font-medium">Sorular</h4>
              <div className="mt-2">
                <h5 className="text-xs text-gray-500 mb-2">Sürükle bırak ile sırala</h5>
                <ul className="ml-0 space-y-2">
                  {questions.map((q, i) => (
                    <li key={q.id || i} draggable onDragStart={(e) => onDragStart(e, i)} onDragOver={(e) => onDragOver(e, i)} onDrop={(e) => onDrop(e, i)} onDragEnd={onDragEnd} className="flex items-center gap-3 p-2 border rounded bg-white">
                      <span className="cursor-grab text-gray-400">☰</span>
                      <div className="flex-1">
                        <div className="font-medium">{q.label}</div>
                        <div className="text-xs text-gray-500">{q.type} — {Array.isArray(q.options) ? q.options.join(', ') : '—'}</div>
                      </div>
                      <div className="text-sm text-gray-500">{i+1}</div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="flex gap-2 mb-3">
              <button onClick={saveTemplate} className="px-4 py-2 bg-primary text-white rounded">Kaydet</button>
              <button onClick={()=>{ setTitle(''); setQuestions([]); setKey('new-user'); setPublishAt(''); }} className="px-4 py-2 border rounded">Temizle</button>
            </div>

            <div className="border-t pt-3">
              <h4 className="text-sm font-medium">Hedef Kitle — Şimdi Ata</h4>
              <div className="flex gap-2 items-center mb-2">
                <select value={targetType} onChange={e=>setTargetType(e.target.value)} className="p-2 border rounded">
                  <option value="all">Tümü</option>
                  <option value="premium">Premium</option>
                  <option value="normal">Normal</option>
                  <option value="list">Özel Liste (ID gir)</option>
                </select>
                {targetType === 'list' && <input placeholder="ID1,ID2,..." value={targetIds} onChange={e=>setTargetIds(e.target.value)} className="p-2 border rounded flex-1" />}
                <button onClick={() => assignNow(editingId)} className="px-3 py-1 bg-primary text-white rounded">Bu Şablonu Ata</button>
              </div>
            </div>

            <div className="mt-4 border-t pt-4">
              <h4 className="text-sm font-medium mb-2">Önizleme — Yeni Kullanıcıya Görünecek Hali (Sadece Görünüm)</h4>
              {questions && questions.length ? (
                <div className="text-sm text-gray-800">
                  <div className="mb-2 font-medium">{title || 'Başlıksız Anket'}</div>
                  <ol className="list-decimal ml-5 space-y-2">
                    {questions.map((q, i) => (
                      <li key={i}>
                        <div className="font-medium">{q.label}</div>
                        {Array.isArray(q.options) && q.options.length ? (
                          <div className="flex flex-wrap gap-2 mt-1">
                            {q.options.map((opt, idx) => (
                              <span key={idx} className="px-2 py-1 bg-gray-100 rounded text-sm text-gray-700">{opt}</span>
                            ))}
                          </div>
                        ) : (
                          <div className="text-sm text-gray-500 mt-1">(Seçenek yok)</div>
                        )}
                      </li>
                    ))}
                  </ol>
                </div>
              ) : (
                <div className="text-sm text-gray-500">Önizlenecek soru yok.</div>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
